// NOTE: 시딩 상세 dev mock(VM/service-response 빌더 + 상태별 JSON)은 실 API 연동·실배포로 전부 제거됨.
// 이 디렉토리에는 실 콘텐츠 설정(CONTENT_GUIDE_INFO_SHEET)만 남는다.
export { CONTENT_GUIDE_INFO_SHEET } from './content-guide-info';
